<template>
  <div>
    <primary-title>表單下載</primary-title>
    <base-box title="查詢條件">
      <v-container grid-list-md>
        <v-layout row
                  wrap
                  class="form">
                  <v-flex sm6>
            <sub-header><template v-slot:title>類別</template>
            </sub-header>
            <div id="polStateID"
                 class="menu-has-id">
                 <v-select v-model="formType"
                 :items="formList"
                 item-text="codeName"
                 item-value="codeValue"
                 label="全部"
                 hide-no-data
                 :menu-props="{ closeOnContentClick: true, auto: true }"
                 outline>
                 <v-list-tile slot="prepend-item"
                 @click="formType = null">
                 <v-list-tile-title>全部</v-list-tile-title>
                </v-list-tile>
              </v-select>
            </div>
          </v-flex>
          <v-flex sm6>
            <sub-header>d<template v-slot:title>表單名稱</template>
            </sub-header>
            <v-text-field placeholder="請輸入"
                          v-model="formName"
                          outline></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </base-box>
    <base-btn>
      <btn-lg-secondary @click.native="queryHandler">查詢</btn-lg-secondary>
    </base-btn>
    <base-container has-title
                    title="查詢結果"
                    v-if="showSearchResult">
      <v-data-table :headers="headers"
                    :items="dataList"
                    :pagination.sync="pagination"
                    :rows-per-page-items="[5,10,15,25,50]"
                    rows-per-page-text="顯示資料筆數"
                    no-data-text="沒有資料可顯示!"
                    class="elevation-1">
        <template v-slot:headers="props">
          <th v-for="header in props.headers"
              :key="header.value"
              :width="header.width">
            <span v-html="header.text"></span>
            <!-- :class="['column', pagination.descending ? 'desc' : 'asc', 'sortable active']" -->
          </th>
        </template>
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.formTypeName }}</td>
            <td>{{ props.item.formName }}</td>
            <td class="text-xs-center">
              <v-btn outline
                     fab
                     small
                     v-ripple="false"
                     @click="downloadHandler(props.item)">
                     <v-icon>download</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-container>
    <!-- 預覽 -->
  </div>
</template>
<script>
export default {
  name: 'formDownload',
  props: {},
  data () {
    return {
      formType: null,
      formName: null,
      dataList: [],
      headers: [
        { text: '類別', align: 'center', value: 'formTypeName', width: '20%' },
        { text: '表單名稱', align: 'center', value: 'formName', width: '50%' },
        { text: '執行', align: 'center', value: 'excute', width: '30%' },
      ],
      pagination: {
        // sortBy: 'period',
        descending: true,
        rowsPerPage: 15
      },
      showSearchResult: false
    }
  },
  created () {

  },
  watch: {
  },
  computed: {
    formList () {
      let list = this.$store.getters['common/admCodeDetail']({
        codeType: 'FORM_TYPE'
      })
      return list
    },
  },
  methods: {
    queryHandler () {
      this.$nextTick(() => {
        this.dataList = []
      })
      const { formType,formName } = this
      const params = { formType,formName, ignoreBLOB: true }
      this.showSearchResult = false
      this.startLoading()
      this.$api.get('/adm/com/formDownload/list', { params }).then(r => {
        this.dataList = r.data || []
        this.showSearchResult = true
        this.$store.dispatch('common/postUserAccessLog', ({ progClassName: 'formDownload_query', methodName: '查詢' }))
        this.endLoading()
      })
    },
    downloadHandler (item) { // 下載
      const idStr = 'formDownload_Link'
      let formCode = item.formCode
      let url = this.$api.defaults.baseURL +
      '/adm/com/formDownload/download?formCode='+ formCode
      // 因為對於 Safari 瀏覽器，由於它不支持 download 屬性，改為在新的分頁中打開檔案
      if (this.$isSafari) {
        window.open(url, "_blank");
      } else {
        let link = null
        link = document.getElementById(idStr)
        if (!link) {
          link = document.createElement('a')
          link.id = idStr
          link.style.display = 'none'
          link.target = '_blank'
          link.rel = 'noopener'
          document.body.appendChild(link)
        }
        link.href = url
        link.setAttribute('download', item.fileName)
        this.startLoading()
        this.$store.dispatch('common/postUserAccessLog', ({ progClassName: 'formDownload_download', methodName: '下載' }))
        link.click()

        setTimeout(() => {
          this.endLoading()
        }, 1000)
      }
    },
    startLoading () {
      this.$store.commit('START')
    },
    endLoading () {
      // this.$store.commit('END')
      let vm = this
      vm.$nextTick(() => {
        setTimeout(() => {
          vm.$store.commit('END')
        }, 1000)
      })
    },
  },
}
</script>
